module.exports = __webpack_public_path__ + "img/Openvoxel-Logo.7952e5ad.svg";